export interface ResendState {
  lastSentAt: number;
  attemptCount: number;
  contactValue: string;
}

export interface ResendConfig {
  initialDelay?: number;
  maxDelay?: number;
  exponentialFactor?: number;
}

const DEFAULT_CONFIG: Required<ResendConfig> = {
  initialDelay: 30,
  maxDelay: 300,
  exponentialFactor: 2,
};

export const resendLogic = {
  getCurrentDelay: (attemptCount: number): number => {
    if (attemptCount === 0) return 0;
    const { initialDelay, maxDelay, exponentialFactor } = DEFAULT_CONFIG;
    const delay = initialDelay * exponentialFactor ** (attemptCount - 1);
    return Math.min(delay, maxDelay);
  },

  getRemainingTime: (resendState: ResendState | null): number => {
    if (!resendState) return 0;

    const { lastSentAt, attemptCount } = resendState;
    const currentDelay = resendLogic.getCurrentDelay(attemptCount);
    const elapsedTime = Math.floor((Date.now() - lastSentAt) / 1000);
    const timeLeft = Math.max(0, currentDelay - elapsedTime);

    return timeLeft;
  },

  canResend: (resendState: ResendState | null): boolean => resendLogic.getRemainingTime(resendState) === 0,

  shouldShowConfirmation: (resendState: ResendState): boolean => resendState.attemptCount >= 2,

  createNewResendState: (contactValue: string, currentState: ResendState): ResendState => {
    const { contactValue: currentContactValue, attemptCount: currentAttemptCount = 0 } = currentState;
    const newAttemptCount = currentContactValue === contactValue ? currentAttemptCount + 1 : 1;

    return {
      lastSentAt: Date.now(),
      attemptCount: newAttemptCount,
      contactValue,
    };
  },
};
